<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <a class="py-4" href="/dashboard">Личный кабинет</a>
                    <v-layout pt-4 pb-5 row wrap>
                        <v-flex xs12 sm6>
                            <h1 class="py-4">Страховые полисы</h1>
                        </v-flex>
                        <v-flex xs12 sm6 style="text-align: right; padding-top: 40px" v-if="showCommissions">
                            <span style="font-size: 18px; display: block">Общее вознаграждение:
                                <span
                                    style="padding-left: 20px; font-size: 40px; font-weight: 700">
                                    {{ this.commissionByMonth + '\xa0₽' }}
                                </span>
                            </span>
                            <osago-month
                                :value="commissionByMonth"
                                @change="balanceDateChanged"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1800px;">
                    <v-layout pb-4 row wrap>
                        <v-flex xs12 sm6 md8>
                            <v-text-field
                                py-5
                                v-model="filters.search"
                                prepend-inner-icon="search"
                                label="Поиск в таблице по ФИО, телефону, e-mail и т.д."
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 md2 pt-4>
                            <v-btn
                                class="submit-button block"
                                @click="newSearch">Поиск
                            </v-btn>
                        </v-flex>
                        <v-flex v-if="role === 'admin' || !this.egarantUser" xs12 sm3 md2 pt-4>
                            <b2b-policy-type-dialog
                                :links="policyTypesArray"
                                :toDisplay="toDisplay"
                                @changeDialog="changeDialog"
                            >
                            </b2b-policy-type-dialog>
                        </v-flex>
                        <v-flex v-else xs12 sm3 md2 pt-4>
                            <v-btn class="submit-button block"
                                   href="/calc"
                                   target="_blank">Новый полис
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <h3 class="py-0">Фильтры</h3>
                    <v-layout py-0 row wrap class="filters">
                        <v-flex xs12 sm6 py0 v-if="showCurators">
                            <v-autocomplete
                                v-model="filters.curator"
                                :items="curatorsList"
                                :loading="isLoadingCuratorsFilter"
                                label="Куратор"
                                :search-input.sync="filters.curatorSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.curatorSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 py0 v-if="showAgents">
                            <v-autocomplete
                                v-model="filters.agent"
                                :items="agentsList"
                                :loading="isLoadingAgentsFilter"
                                label="Агент"
                                :search-input.sync="filters.agentSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.agentSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 py0 v-if="showOperators">
                            <v-autocomplete
                                v-model="filters.operator"
                                :items="operatorsList"
                                :loading="isLoadingOperatorsFilter"
                                label="Сотрудник"
                                :search-input.sync="filters.operatorSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.operatorSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 py0
                                :class="role === 'admin' ? 'sm4' : 'sm6'"
                                v-if="role === 'admin' || !filters.is_egarant">
                            <v-select
                                v-model="filters.company"
                                :items="filters.is_egarant ? egarantCompaniesList : companiesList"
                                label="Страховая компания"
                                item-value='alias'
                                item-text='name'
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm2 py0
                                v-if="role === 'admin'">
                            <v-checkbox
                                v-model="filters.is_egarant"
                                label="Е-Гарант"
                                @change="isEgarantChanged"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout py-0 row wrap class="filters">
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Оформлен, от"
                                v-model="filters.date_from"
                                :yearStarting="false"
                                :max="filters.date_to"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Оформлен, до"
                                v-model="filters.date_to"
                                :yearStarting="false"
                                :min="filters.date_from"
                                :isRequired="false"
                            />
                        </v-flex>

                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата начала, от"
                                v-model="filters.beg_date_from"
                                :yearStarting="false"
                                :max="filters.beg_date_to"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата начала, до"
                                v-model="filters.beg_date_to"
                                :yearStarting="false"
                                :min="filters.beg_date_from"
                                :isRequired="false"
                            />
                        </v-flex>

                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата окончания, от"
                                v-model="filters.end_date_from"
                                :yearStarting="false"
                                :max="filters.end_date_to"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата окончания, до"
                                v-model="filters.end_date_to"
                                :yearStarting="false"
                                :min="filters.end_date_from"
                                :isRequired="false"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout py-0 row wrap class="filters">
                        <v-flex v-if="showSegment" xs12 sm2 py0>
                            <v-select
                                v-model="filters.segment"
                                :items="segmentsList"
                                label="Канал продаж"
                                item-value='id'
                                item-text='name'
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm2 py0>
                            <v-select
                                v-model="filters.policy_type"
                                :items="typesList"
                                label="Тип полиса"
                                item-value='id'
                                item-text='name'
                            ></v-select>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs6 sm8 md9 lg10>
                            <a @click="cleanFilters" class="link">Очистить все</a>
                        </v-flex>

                        <v-flex xs6 sm4 md3 lg2>
                            <download-excel
                                class="d-inline-block"
                                name="policy-list.xls"
                                worksheet="Полисы"
                                :fetch="downloadItems"
                                :fields="downloadFields"
                            >
                                <a class="link">Выгрузить результат</a>
                            </download-excel>

                            <v-menu
                                class="d-inline-block"
                                d-inline
                                :close-on-content-click="false"
                                offset-x
                            >
                                <template #activator="{ on: menu }">
                                    <v-tooltip bottom>
                                        <template #activator="{ on: tooltip }">
                                            <v-btn
                                                icon
                                                v-on="{ ...tooltip, ...menu }"
                                            >
                                                <v-icon>settings</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Управление колонками</span>
                                    </v-tooltip>
                                </template>

                                <v-list>
                                    <v-list-tile
                                        v-for="(item) in toggleableColumns"
                                        :key="item.id"
                                    >
                                        <v-list-tile-action>
                                            <v-checkbox
                                                class="mh-0-important"
                                                :input-value="shownToggleableColumns[item.id]"
                                                @change="toggleColumn($event, item.id)"
                                            />
                                        </v-list-tile-action>
                                        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-flex>
                    </v-layout>

                    <v-tabs
                        v-model="tab"
                        slider-color="#000"
                        show-arrows
                    >
                        <v-tab v-for="(tab, index) in tabsList" :key="index"
                               @click="changeTab(index)"
                        >
                            {{ tab }}
                        </v-tab>
                    </v-tabs>

                    <v-data-table
                        py-5
                        ref="policyListTable"
                        v-model="selected"
                        :headers="headers"
                        :items="rows"
                        :pagination.sync="pagination"
                        :total-items="totalRows"
                        :loading="loading"
                        item-key="1"
                        :rows-per-page-items="[10,25,50]"
                        rows-per-page-text="Показывать по"
                        select-all
                        no-data-text="Нет данных"
                        no-results-text="Ничего не найдено"
                    >
                        <template v-slot:no-results>
                            <v-layout py-5>
                                <p>Ничего не найдено. <a @click="cleanFilters">Очистить фильтры</a></p>
                            </v-layout>
                        </template>
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                                    <v-checkbox
                                        :input-value="props.all"
                                        :indeterminate="props.indeterminate"
                                        primary
                                        hide-details
                                        @click.stop="toggleAll"
                                    ></v-checkbox>
                                </th>
                                <th
                                    v-for="header in props.headers"
                                    v-if="!header.toggleable || (header.toggleable && shownToggleableColumns[parseInt(header.value)])"
                                    :key="header.text"
                                    :class="[
                                        'column text-xs-left',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.sortable === false ? '' : 'sortable',
                                        header.value === pagination.sortBy ? 'active' : '']"
                                    @click="header.sortable !== false && changeSort(header.value)"
                                >
                                    {{ header.text }}
                                    <v-icon v-if="header.sortable !== false" small>arrow_upward</v-icon>
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="rowClicked(props.item)">
                                <td @click.stop="">
                                    <v-checkbox
                                        v-model="props.selected"
                                        primary
                                        hide-details
                                    ></v-checkbox>
                                </td>
                                <template v-if="showCurators">
                                    <td>{{ props.item[19] || '—' }}<br>{{ props.item[20] }}</td>
                                </template>
                                <template v-if="showAgents">
                                    <td>{{ props.item[17] || '—' }}<br>{{ props.item[18] || '—' }}</td>
                                </template>
                                <template v-if="showOperators && shownToggleableColumns[23]">
                                    <td>{{ props.item[23] || '—' }}<br>{{ props.item[24] || '—' }}</td>
                                </template>
                                <td>{{ props.item[2] }}<br>{{ props.item[15] }}<br>{{ props.item[16] }}</td>
                                <td>{{ props.item[31] || '—' }}</td>
                                <template v-if="showSegment && shownToggleableColumns[30]">
                                    <td>{{ props.item[30] || '—' }}</td>
                                </template>
                                <td>{{ props.item[4].slice(0, 10) }}<br>в {{ props.item[4].slice(11, 16) }}</td>
                                <td>{{ props.item[22] || '—' }}</td>
                                <td v-if="shownToggleableColumns[5]">{{ props.item[6] || '—' }}</td>
                                <td class="ins-logo-container"> <!-- Лого компании -->
                                    <img v-if="props.item[8] && props.item[10] == 'Оформлен' " class="ins-logo"
                                         :src="props.item[8]"/>
                                    {{ props.item[8] ? '' : props.item[7] }}
                                </td>
                                <td>{{ props.item[10] || '—' }}</td>
                                <template v-if="showCommissions">
                                    <td class="text-md-center no-wrap">{{ props.item[12] && props.item[10] == 'Оформлен' ? props.item[12] : '—' }}</td>
                                </template>
                                <td class="text-md-center no-wrap">{{ props.item[14] && props.item[10] == 'Оформлен' ? props.item[14] : '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[29]">{{ props.item[29] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[32]">{{ props.item[32] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[33]">{{ props.item[33] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[34]">{{ props.item[34] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[35]">{{ props.item[35] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[36]">{{ props.item[36] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[37]">{{ props.item[37] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[38]">{{ props.item[38] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[39]">{{ props.item[39] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[40]">{{ props.item[40] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[41]">{{ props.item[41] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[42]">{{ props.item[42] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[43]">{{ props.item[43] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[44]">{{ props.item[44] || '—' }}</td>
                                <td class="text-md-center no-wrap" v-if="shownToggleableColumns[45]">{{ props.item[45] || '—' }}</td>
                                <td class="text-xs-right px-0" @click.stop="">
                                    <v-menu>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-tile
                                                :href="'/order/' + props.item[0]"
                                                target="_blank"
                                                v-if="props.item[9]===1000"
                                            >
                                                <v-list-tile-title>Просмотр</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/order/' + props.item[0] + '/edit'"
                                                target="_blank"
                                                v-if="props.item[9]!==1000 && !props.item[28]"
                                            >
                                                <v-list-tile-title>Редактировать</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/order/' + props.item[0] + '/prolong'"
                                                target="_blank"
                                                v-if="props.item[9]===1000 && !props.item[28]"
                                            >
                                                <v-list-tile-title>Продлить</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/order/' + props.item[0] + '/draft'"
                                                target="_blank"
                                            >
                                                <v-list-tile-title>Использовать как черновик</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                @click="download(props.item)"
                                                v-if="props.item[9]===1000"
                                            >
                                                <v-list-tile-title>Скачать</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                @click="del(props.item)"
                                                v-if="props.item[9]!==1000"
                                            >
                                                <v-list-tile-title>Удалить</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:pageText="props">
                            {{ props.pageStart }} - {{ props.pageStop }} из {{ props.itemsLength }}
                        </template>
                    </v-data-table>

                    <v-layout py-0 row wrap>
                        <v-flex xs6 v-show="selected.length" style="margin-top: -70px">
                            Выделено полисов: {{ selected.length }}<br>
                            <a @click="groupDel(selected)" class="link">Удалить выделенные</a>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>

</template>

<script>
    import _ from 'lodash'
    import PolicyTypeDialogButton from "../elements/PolicyTypeDialogButton";

    export default {
        props: [
            'role',
            'showcommissions',
            'showsegment',
            'list',
            'total',
            'errors',
            'companies',
            'egarant-companies',
            'egarant-user',
            'policy-types'
        ],

        components: {
            'b2b-policy-type-dialog': PolicyTypeDialogButton
        },

        data: () => ({
            filters: {
                tab: 0,
                search: '',
                curatorSearch: '',
                agentSearch: '',
                operatorSearch: '',
                company: '',
                date_from: null,
                date_to: null,
                beg_date_from: null,
                beg_date_to: null,
                end_date_from: null,
                end_date_to: null,
                curator: [],
                agent: [],
                operator: [],
                is_egarant: false,
                segment: null,
                policy_type: null,
            },
            pagination: {
                descending: true,
                sortBy: '3',
                page: 1,
                rowsPerPage: 10,
                totalItems: 0
            },
            companiesList: [],
            egarantCompaniesList: [],
            tabsList: ['Все', 'Черновики', 'Подтверждённые', 'Оформленные'],
            curatorsList: [],
            agentsList: [],
            operatorsList: [],
            segmentsList: [{id: null, name: 'Любой'}, {id: 'B2B', name: 'B2B'}, {id: 'B2C', name: 'B2C'}],
            typesList: [
                {id: null, name: 'Любой'},
                {id: 'OSAGO_NEW', name: 'ОСАГО'},
                {id: 'OSAGO_PROLONG', name: 'Пролонгация ОСАГО'},
                {id: 'MORTGAGE', name: 'Страхование ипотеки'}
            ],

            headers: [],
            rows: [],
            totalRows: 0,
            selected: [],
            tab: 0,
            toggleableColumns: [],
            shownToggleableColumns: {},

            downloadFields: {},

            showCurators: false,
            showAgents: false,
            showOperators: false,
            showCommissions: false,
            showSegment: false,

            loading: false,
            canDownload: false,
            init: false,

            isLoadingOperatorsFilter: false,
            isLoadingAgentsFilter: false,
            isLoadingCuratorsFilter: false,
            monthCommission: 0,
            commissionByMonth: '',

            policyTypesArray: [],
            toDisplay: false,
        }),

        watch: {
            'pagination.descending': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.sortBy': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.page': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.rowsPerPage': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.totalItems': {
                handler() {
                    this.paginationHandle();
                }
            },
            filters: {
                handler() {
                    if (!this.init) {
                        return;
                    }
                    // TODO: для обработки доступности кнопки
                    //console.log('I\'ll be watching you', this.filters);
                },
                deep: true
            }
        },

        created: function () {
            if (this.errors) {
                PNotify.error('Возникли ошибки при поиске');
                console.log(this.error);
            }
            if (this.role === 'admin') {
                this.showCurators = true;
                this.showAgents = true;
                this.showOperators = true;
                this.showCommissions = true;
                this.showSegment = true;
            } else if (this.role === 'curator') {
                this.showAgents = true;
                this.showOperators = true;
                this.showCommissions = true;
                this.showSegment = this.showsegment;
            } else if (this.role === 'agent') {
                this.showOperators = true;
                this.showCommissions = true;
                this.showSegment = this.showsegment;
            } else if (this.role === 'operator') {
                this.showCommissions = this.showcommissions;
                this.showSegment = this.showsegment;
            }

            if (this.role !== 'admin') {
                this.filters.is_egarant = this.egarantUser;
            }

            this.rows = JSON.parse(window.atob(this.list));
            this.totalRows = this.total;

            this.headers = [
                {text: 'Куратор', value: '19', sortable: false},
                {text: 'Агент', value: '17', sortable: false},
                {text: 'Сотрудник', value: '23', sortable: false, toggleable: true, visibleDefault: true},
                {text: 'Страхователь', value: '2', sortable: false, width: 200},
                {text: 'Тип полиса', value: '31', sortable: false},
                {text: 'Канал продаж', value: '30', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Оформлен', value: '3'},
                {text: 'Дата начала', value: '21'},
                {text: 'Дата окончания', value: '5', toggleable: true, visibleDefault: false},
                {text: 'Компания', value: '7', sortable: false},
                {text: 'Статус', value: '9', sortable: false},
                {text: 'Вознаграждение', value: '11', sortable: false},
                {text: 'Страховая премия', value: '13', sortable: false},
                {text: 'КБМ', value: '29', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Адрес регистрации', value: '32', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Пул', value: '33', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Гос. Номер', value: '34', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Марка ТС', value: '35', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Модель', value: '36', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'VIN / № Кузова', value: '37', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Год выпуска', value: '38', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Мощность ТС', value: '39', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Стоимость кросс', value: '40', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Зеленый коридор', value: '41', sortable: false, toggleable: true,  visibleDefault: false},
                {text: 'Предыдущая СК', value: '42', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Мощность ТС Автокод', value: '43', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Номер полиса в РСА', value: '44', sortable: false, toggleable: true, visibleDefault: false},
                {text: 'Примененная сегментация', value: '45', sortable: false, toggleable: true, visibleDefault: false},
                {text: '', value: '', sortable: false, class: 'px-0'},
            ];

            let toggleable = [];
            let shownToggleable = {};
            this.headers.forEach(header => {
                if (header.toggleable) {
                    const id = parseInt(header.value);
                    toggleable.push({'name': header.text, 'id': id });
                    shownToggleable[id] = header.visibleDefault;
                }
            });
            this.toggleableColumns = toggleable;
            this.shownToggleableColumns = shownToggleable;

            this.downloadFields = {
                '#': '0',
                'Куратор': '19',
                'Email куратора': '20',
                'Агент': '17',
                'Email агента': '18',
                'Сотрудник': '23',
                'Email сотрудника': '24',
                'Страхователь': '2',
                'Адрес Регистрации': '32',
                'Гос. Номер': '34',
                'Марка ТС': '35',
                'Модель': '36',
                'VIN / № Кузова': '37',
                'Год выпуска': '38',
                'Мощность ТС': '39',
                'Мощность ТС Автокод': '43',
                'Телефон страхователя': '15',
                'Email страхователя': '16',
                'Канал продаж': '30',
                'Дата оформления': '4',
                'Дата начала': '22',
                'Дата окончания': '6',
                'Компания': '7',
                'Статус': '10',
                'Вознаграждение': '11',
                'Страховая премия': '13',
                'Пулл': '33',
                'Стоимость кросс': '40',
                'Предыдущий полис активен': '41',
                'СК предыдущего полиса': '42',
                'КБМ': '29',
                'Тип полиса': '31',
                'Номер полиса в РСА': '44',
                'Примененная сегментация': '45',
            };

            if (!this.showCurators) {
                _.remove(this.headers, {text: 'Куратор'});
                delete this.downloadFields['Куратор'];
                delete this.downloadFields['email куратора'];
            }
            if (!this.showAgents) {
                _.remove(this.headers, {text: 'Агент'});
                delete this.downloadFields['Агент'];
                delete this.downloadFields['email агента'];
            }
            if (!this.showOperators) {
                _.remove(this.headers, {text: 'Сотрудник'});
                delete this.downloadFields['Сотрудник'];
                delete this.downloadFields['email сотрудник'];
            }
            if (!this.showCommissions) {
                _.remove(this.headers, {text: 'Вознаграждение'});
                delete this.downloadFields['Вознаграждение'];
            }
            if (!this.showSegment) {
                _.remove(this.headers, {text: 'Канал продаж'});
                delete this.downloadFields['Канал продаж'];
            }

            this.companiesList = Object.values(JSON.parse(window.atob(this.companies)));
            this.companiesList.sort(this.sortByName).unshift({alias: 'all', name: 'Все'});
            this.egarantCompaniesList = JSON.parse(window.atob(this.egarantCompanies));
            this.egarantCompaniesList.sort(this.sortByName).unshift({alias: 'all', name: 'Все'});

            this.policyTypesArray = JSON.parse(window.atob(this.policyTypes));

            this.searchOperatorsFilter();
            this.searchAgentsFilter();
            this.searchCuratorsFilter();

            this.init = true;

            let newPolisButtons = [...document.getElementsByClassName('newPolis')]
            newPolisButtons.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.toDisplay = true
                })
            })
        },

        methods: {

            changeDialog(value) {
                this.toDisplay = value
            },

            newSearch() {
                if (this.loading) {
                    return;
                }
                const data = {
                    s: this.pagination.sortBy,
                    desc: this.pagination.descending,
                    p: this.pagination.page,
                    i: this.pagination.rowsPerPage,
                    f: JSON.stringify(this.filters)
                };
                this.loading = true;
                axios.post('/policy-list-old', data)
                    .then(response => {
                        if (response.data && response.data.status === 'success') {
                            this.rows = JSON.parse(window.atob(response.data.list));
                            this.totalRows = response.data.total;
                        } else {
                            PNotify.error('Возникли ошибки при поиске');
                            console.log(response);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        PNotify.error('Возникли ошибки при поиске');
                    })
                    .finally(() => { this.loading = false; });
            },

            rowClicked(item) {
                // window.open может быть подавлен политикой Firefox по запрету всплывающих окон,
                // поэтому конструируем новый элемент и кликаем по нему, а потом удаляем
                let link = document.createElement('a');
                link.id = 'my_link';
                link.style.cssText = 'display: none';
                link.href = item[9] === 1000 || item[28] ? '/order/' + item[0] : '/order/' + item[0] + '/edit';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                link = undefined;
            },

            toggleAll() {
                if (this.selected.length) {
                    this.selected = [];
                } else {
                    this.selected = this.$refs.policyListTable.filteredItems.slice();
                }
            },

            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending;
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false;
                }
            },

            changeTab(index) {
                this.filters.tab = index;
                this.pagination.page = 1;
            },

            cleanFilters() {
                this.filters.search = '';
                this.filters.curatorSearch = '';
                this.filters.agentSearch = '';
                this.filters.operatorSearch = '';
                this.filters.company = '';
                this.filters.date_from = null;
                this.filters.date_to = null;
                this.filters.beg_date_from = null;
                this.filters.beg_date_to = null;
                this.filters.end_date_from = null;
                this.filters.end_date_to = null;
                this.filters.agent = [];
                this.filters.curator = [];
                this.filters.operator = [];
                if (this.role === 'admin') {
                    this.filters.is_egarant = false;
                }
                this.filters.segment = null;
                this.filters.policy_type = null;
                this.newSearch();
            },

            async downloadItems() {
                if (this.loading) {
                    return;
                }
                const data = {
                    s: this.pagination.sortBy,
                    desc: this.pagination.descending,
                    p: this.pagination.page,
                    i: -1,
                    f: JSON.stringify(this.filters)
                };
                this.loading = true;
                let result = [];
                await axios.post('/policy-list-old', data)
                    .then(response => {
                        if (response.data && response.data.status === 'success') {
                            result = JSON.parse(window.atob(response.data.list));
                        } else {
                            PNotify.error('Возникли ошибки при формировании файла');
                            console.log(response);
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        PNotify.error('Возникли ошибки при формировании файла');
                        this.loading = false;
                    });

                return result;
            },

            download(item) {
                window.location.href = '/order/' + item[0] + '/download';
            },

            del(item) {
                let that = this;
                PNotify.error({
                    text: 'Удалить полис?',
                    hide: false,
                    stack: {
                        'dir1': 'down',
                        'modal': true,
                        'firstpos1': 25
                    },
                    modules: {
                        Confirm: {
                            confirm: true,
                            buttons: [
                                {
                                    text: 'Удалить',
                                    primary: false,
                                    click: function () {
                                        axios.get('/order/' + item[0] + '/delete')
                                            .then(response => {
                                                Vue.delete(that.rows, that.rows.findIndex((v) => v[0] === item[0]));
                                                PNotify.removeAll();
                                            }).catch(error => {
                                                console.log(error.response);
                                                PNotify.removeAll();
                                                if (error.response && error.response.data.message) {
                                                    PNotify.alert(error.response.data.message);
                                                }
                                            });
                                    },
                                },
                                {
                                    text: 'Отмена',
                                    primary: false,
                                    click: () => {
                                        PNotify.removeAll();
                                    },
                                }
                            ]
                        },
                        Buttons: {
                            closer: false,
                            sticker: false
                        },
                        History: {
                            history: false
                        }
                    }
                });
            },

            groupDel(items) {
                let that = this;
                PNotify.error({
                    text: 'Удалить полисы? (Всего: ' + items.length + ')',
                    hide: false,
                    stack: {
                        'dir1': 'down',
                        'modal': true,
                        'firstpos1': 25
                    },
                    modules: {
                        Confirm: {
                            confirm: true,
                            buttons: [
                                {
                                    text: 'Удалить',
                                    primary: false,
                                    click: function () {
                                        axios.post('/list/delete', {orders: items.join(',')})
                                            .then(response => {
                                                response.data.deleted.forEach(
                                                    (uuid) => Vue.delete(
                                                        that.rows,
                                                        that.rows.findIndex((v) => v[0] === uuid)
                                                    )
                                                );
                                                PNotify.removeAll();

                                                if (items.length !== response.data.deleted.length) {
                                                    PNotify.alert(`Удалено ${ response.data.deleted.length } из ${ items.length }:
                                                        для остальных отсутствуют права на удаление либо не позволяет статус полиса.`);
                                                }
                                            }).catch(error => {
                                                console.log(error.response);
                                                PNotify.removeAll();
                                                if (error.response && error.response.data.message) {
                                                    PNotify.alert(error.response.data.message);
                                                }
                                            });
                                    },
                                },
                                {
                                    text: 'Отмена',
                                    primary: false,
                                    click: () => {
                                        PNotify.removeAll();
                                    },
                                }
                            ]
                        },
                        Buttons: {
                            closer: false,
                            sticker: false
                        },
                        History: {
                            history: false
                        }
                    }
                });
            },

            isEgarantChanged() {
                this.filters.company = '';
            },

            sortByName(objA, objB) {
                return objA.name < objB.name ? -1 : 1;
            },

            paginationHandle() {
                if (!this.init) {
                    return;
                }
                this.newSearch();
            },

            async searchOperatorsFilter() {
                // Данные загружаются или уже получены
                if (this.isLoadingOperatorsFilter || this.operatorsList.length > 0) {
                    return;
                }
                this.isLoadingOperatorsFilter = true;
                axios.get('/policy-operators-old').then(response => {
                    this.operatorsList = JSON.parse(window.atob(response.data.data));
                    this.operatorsList.sort(this.sortByName);
                }).catch(error => {
                    console.log(error);
                    PNotify.alert('Не удалось получить список сотрудников');
                }).finally(() => { this.isLoadingOperatorsFilter = false; })
            },

            async searchAgentsFilter() {
                // Данные загружаются или уже получены
                if (this.isLoadingAgentsFilter || this.agentsList.length > 0) {
                    return;
                }
                this.isLoadingAgentsFilter = true;
                axios.get('/policy-agents-old').then(response => {
                    this.agentsList = JSON.parse(window.atob(response.data.data));
                    this.agentsList.sort(this.sortByName);
                }).catch(error => {
                    console.log(error);
                    PNotify.alert('Не удалось получить список агентов');
                }).finally(() => { this.isLoadingAgentsFilter = false; })
            },

            async searchCuratorsFilter() {
                // Данные загружаются или уже получены
                if (this.isLoadingCuratorsFilter || this.curatorsList.length > 0) {
                    return;
                }
                this.isLoadingCuratorsFilter = true;
                axios.get('/policy-curators-old').then(response => {
                    this.curatorsList = JSON.parse(window.atob(response.data.data));
                    this.curatorsList.sort(this.sortByName);
                }).catch(error => {
                    console.log(error);
                    PNotify.alert('Не удалось получить список кураторов');
                }).finally(() => { this.isLoadingCuratorsFilter = false; })
            },

            toggleColumn(event, index) {
                this.shownToggleableColumns[index] = event;
            },

            balanceDateChanged(val) {
                axios.get('/accounting-balance?month=' + val).then(response => {
                    if (response.data && response.data.status === 'ok') {
                        this.commissionByMonth = response.data.sum;
                    } else {
                        console.log(response);
                        PNotify.alert('Не удалось получить баланс');
                    }
                }).catch(error => {
                    console.log(error);
                    PNotify.alert('Не удалось получить баланс');
                });
            }
        }
    }

    function dateToTimestampSeconds(val) {
        // val must be in 'YYYY-MM-DD' format
        const a = val.split(/[^0-9]/);
        return (new Date(a[0], a[1]-1, a[2]).getTime() / 1000).toFixed(0);
    }

    function objectArrayHasItemWithAttr(arr, attr, value) {
        if (!arr || arr.length === 0) return false;
        for (let i = 0; i < arr.length; i++) {
            if(arr[i][attr] === value) {
                return true;
            }
        }
        return false;
    }
</script>

<style scoped>

    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 56px;
        width: 100%;
        background-color: #00ba57 !important;
        text-align: center;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    /deep/ .v-btn__content {
        margin: 0 !important;
        line-height: 1.1;
    }

    .preview-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 19px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 70px;
        width: 90%;
        background-color: #00ba57 !important;
        text-align: center;
        padding: 0 30px !important;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    /deep/ .v-tabs__item {
        justify-content: left;
        text-transform: none;
        font-size: 16px;
        font-weight: 500;
    }

    /deep/ .v-tabs__item--active {
        font-weight: 700;
    }

    .agent-actions a {
        color: black;
        margin-right: 40px;
    }

    .agent-actions a img {
        margin-right: 5px;
        width: 21px;
        height: 21px;
        vertical-align: -5px;
    }

    .agent-actions a.disabled {
        color: grey;
    }

    .agent-actions a.disabled img {
        color: grey;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    /deep/ table.v-table tbody td,
    /deep/ table.v-table tbody th {
        height: 110px;
    }

    /deep/ table.v-table tbody td,
    /deep/ table.v-table thead th {
        font-size: 14px;
    }

    /deep/ table.v-table thead td,
    /deep/ table.v-table tbody td,
    /deep/ table.v-table thead th,
    /deep/ table.v-table tbody th {
        padding: 0 5px;
    }

    /deep/ table.v-table tbody td {
        cursor: pointer;
    }

    /deep/ table.v-table tbody td:not(:nth-child(1)),
    /deep/ table.v-table tbody td:first-child {
        white-space: pre-line;
    }

    /deep/ table.v-table thead tr th {
        max-width: fit-content;
        white-space: normal;
    }

    /deep/ table.v-table thead tr th.sortable {
        white-space: nowrap;
    }

    .ins-logo-container {
        white-space: nowrap !important;
    }

    .ins-logo {
        max-height: 32px;
        max-width: 118px;
        vertical-align: middle;
    }

    .link {
        font-size: 14px;
        text-decoration: underline;
    }

    /deep/ .filters .v-input__slot,
    /deep/ .filters .v-input__control,
    /deep/ .filters .v-text-field {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    /deep/ .mh-0-important input {
        min-height: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/PolicyListOld.vue